export default __webpack_public_path__ + "static/media/jNZD.12f53b81.svg";